import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is carried by an httpOnly cookie set by the backend. withCredentials
// ensures the cookie is sent on every request; no token is kept in JS.
const api = axios.create({ baseURL: API, withCredentials: true });

// Build an invite/reset link from the current origin so it works in any deployment.
export function authLink(token, type) {
  return `${window.location.origin}/activate?token=${encodeURIComponent(token)}&type=${type}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
